module.exports = __webpack_public_path__ + "static/media/3.65dde6fb.svg";